import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';
import { DialogService } from '@services/dialog/dialog.service';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-pipe-imports',
    templateUrl: './pipe-imports.component.html',
    styleUrls: ['./pipe-imports.component.scss'],
    providers: [PipeImportService, DialogService],
    standalone: false
})
export class PipeImportsComponent implements OnInit {

  public title = 'Pipe Imports';

  public description = 'loading';

  public pageActions: PageAction[];

  public columns = [{ prop: 'title', name: 'Title' }];

  @ViewChild('importTable') importTable: DataTableComponent;

  public params: any;

  constructor(
    public pipeImportService: PipeImportService,
    private router: Router,
    private dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    this.params = { toDelete: false };
    this.createPageActions();
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['pipe-imports/', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['pipe-imports', event.row._id, 'edit']);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService.confirm('Remove pipe importer? Consider that this will also delete all imported data').then(res => {
      if (!res) {
        return;
      }
      return this.pipeImportService.remove(event.row._id).then(() => {
        this.importTable.refresh();
      });
    }).catch(error => {
      const message = (error.error.message ? error.error.message : error.message);
      return this.dialogService.confirm(message, error.name);
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create Pipe Import',
        callback: () => {
          this.router.navigate(['pipe-imports/create']);
        }
      })
    ];
  }
}
